import React from 'react'
import { TimelineSpan } from '../../domain/TimelineSpan'
import { getTraceSpanCategory, TraceSpanCategory } from '../../domain/Trace'
import SpanService from '../spanService'
import TraceDetailsSpan, { SpanTraceInfo } from './TraceDetailsSpan'
import { TraceDetailsTitle } from './TraceDetailsTitle'
import { SpanPaginationControls } from './SpanPaginationControls'
import { Box } from '../../ui/box'

interface Props {
    spans: TimelineSpan[]
    allSpans: TimelineSpan[]
    spanService: SpanService
    wt: number
    mc: number
    categories: { [category: string]: TraceSpanCategory }
    route: string
    publicVersion: boolean
    selectedSpanId?: string
    traceInfoBySpanId?: { [spanId: string]: SpanTraceInfo }
    onSelectedSpanChange?: (span: TimelineSpan) => void
}

const pageForSpanId = (selectedSpanId: string | undefined, spans: TimelineSpan[]): number => {
    if (!selectedSpanId) {
        return 1
    }

    const index = spans.findIndex(span => span.id === selectedSpanId)

    return index === -1 ? 1 : index + 1
}

export class PaginatedSpanDetails extends React.PureComponent<Props> {
    private pageForSpanId = pageForSpanId

    public render() {
        const totalPages = this.props.spans.length
        if (totalPages === 0) {
            return null
        }

        const currentPage = Math.min(this.pageForSpanId(this.props.selectedSpanId, this.props.spans), totalPages)
        const currentSpan = this.props.spans[currentPage - 1]
        const showPagination = totalPages > 1

        return (
            <>
                {showPagination ? (
                    <div className="clearfix tw-mt-16">
                        <div>
                            <SpanPaginationControls
                                spans={this.props.spans}
                                allSpans={this.props.allSpans}
                                currentPage={currentPage}
                                totalPages={totalPages}
                                traceDuration={this.props.wt}
                                onPageChange={page => this.setCurrentPage(page)}
                            />
                        </div>
                    </div>
                ) : null}
                <Box className="tw-mt-8">
                    <TraceDetailsTitle
                        isRoot={false}
                        category={getTraceSpanCategory(currentSpan)}
                        name={currentSpan.name}
                        namespace={currentSpan.annotations?.namespace || undefined}
                        async={currentSpan.async}
                    />
                    <TraceDetailsSpan
                        wt={this.props.wt}
                        mc={this.props.mc}
                        span={currentSpan}
                        parents={this.props.spanService.getParents(this.props.allSpans, currentSpan)}
                        traceInfo={this.props.traceInfoBySpanId?.[currentSpan.id]}
                        categories={this.props.categories}
                        route={this.props.route}
                        showSettingsLink={!this.props.publicVersion}
                        bottleneckRoute={
                            this.props.publicVersion
                                ? 'XhprofCoreBundle.Public.sharedTrace.bottlenecks'
                                : 'XhprofProfilerBundle.Profile.bottlenecksReport'
                        }
                    />
                </Box>
            </>
        )
    }

    private setCurrentPage(currentPage: number) {
        const currentSpan = this.props.spans[currentPage - 1]

        if (currentSpan) {
            this.props.onSelectedSpanChange?.(currentSpan)
        }
    }
}
